export default {
	field: {
		width: "100%",
		height: "50px",
		border: "1px solid #acbee8",
		borderRadius: "5px",

		"@media (max-width: 767px)": {
			height: "45px"
		},

		"& .MuiOutlinedInput-root": {
			padding: "0px !important"
		},

		"& .MuiOutlinedInput-root .MuiAutocomplete-input": {
			padding: "16.5px 14px !important"
		},

		"& input": {
			fontSize: "14px",
			color: "#465578"
		},

		"& fieldset": {
			border: "none"
		}
	},

	options: {
		padding: "0px !important",
		fontSize: "14px",

		"& li": {
			margin: "0px !important",
			padding: "6px 17px !important",
			color: "black"
		}
	}
}
